import React from 'react';
import styled from 'styled-components';
import {
  Box,
  FormFooter,
  Button,
  CopiedMessage,
  notification,
  themeUtils as tu,
} from '@zen-common/components-base';
import { useCopy } from '@zen/common-react-hooks';

export default function CopyResultFormFooter({ fields }) {
  const [copied, copyError, onCopy] = useCopy({
    value: JSON.stringify(fields),
  });

  const handleCopy = () => {
    if (fields && fields.messageBody) {
      if (!copied) {
        notification(
          'All data has been copied to the clipboard, please paste in the wallet to execute the contract',
          { type: 'success' }
        );
      }
      onCopy();
    }
  };

  return (
    <>
      <FormFooter mb="0">
        <Button onClick={handleCopy}>Copy all</Button>
      </FormFooter>
      <CopiedMessageWrapper>
        <CopiedMessage copied={copied} error={copyError} />
      </CopiedMessageWrapper>
    </>
  );
}

const CopiedMessageWrapper = styled(Box)`
  display: flex;

  ${tu.mq({
    justifyContent: ['center', 'flex-end'],
  })}
`;
